import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import { updateHDEAnalysis, updateSDEAnalysis } from "../../../../store/modules/qualityOfEarnings/actions";

function Item({ name, data, bold = false, margin = false, manuality = false, dispatchUpdate }) {

  return (
    <div className={`flex items-center ${bold && "font-semibold"} ${(manuality || margin) ? "mt-1" : "mt-5"}`}>
      <div className="whitespace-nowrap flex items-center" style={{ minWidth: "18em" }}>
        <label className={margin ? "text-xs" : ""}>{name}</label>
      </div>
      <div className="flex">
        {data?.map((obj, index) => manuality ?
          <div className="flex" style={{ width: "10em" }}>
            <BVAInput
              startAdornment
              startAdornmentLabel="$ "
              width="95%"
              size="small"
              key={index}
              value={obj.value}
              onChange={(value) =>
                dispatchUpdate("MANUAL", value, index, "manual" + name.replace(/Total|[ &-]/g, ""), index)
              }
            />
          </div>
          :
          <div className="flex" style={{ minWidth: "10em" }}>
            <div style={{ minWidth: "1.3em" }} />
            <label className={margin ? "text-xs" : ""}>
              {CurrencyFormatter.format(obj?.value, {
                code: margin ? "" : "USD",
              })}
              {margin ? "%" : ""}
            </label>
          </div>
        )}
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdate(label, value, id, type, key) {
    dispatch(updateHDEAnalysis(label, value, id, type, key));
    dispatch(updateSDEAnalysis(label, value, id, type, key));
  },
});

export default connect(null, mapDispatchToProps)(Item);
